import { ReplyLeft } from '../icons'
import styles from './styles.module.scss'

function BotReturnButton({ handleClick, text }) {
  return (
    <button className={styles.bot_return_button} onClick={handleClick}>
      <span>{text}</span>
      <ReplyLeft className={styles.return_icon} color="#999999" />
    </button>
  )
}

export default BotReturnButton
